import React from 'react';
import {connect} from 'react-redux';
import {login} from '../actions/UsuarioActions';
import {Redirect} from 'react-router-dom';
import './Login.css';

class Login extends React.Component {
  constructor(props){
    super(props);
    document.title = "Login :: Alpha Ultrapress";
    this.state = {
      credentials: {
        login: "",
        senha: ""
      }
    };
  }

  onChange(event){
    const field = event.target.name;
    const credentials = this.state.credentials;
    credentials[field] = event.target.value.trim();
    return this.setState({credentials});
  }

  handleFormSubmit(event){
    event.preventDefault();
    this.props.login(this.state.credentials);
  }

  render(){
    if(this.props.usuario){
      return (
        <Redirect to="/" />
      )
    }

    return (
      <div className="login-page">
        <form onChange={this.onChange.bind(this)} onSubmit={this.handleFormSubmit.bind(this)}>
          <div className="login-card">
            <img src="images/logo-alpha-convite.png" width="150" alt="Alpha Convites"/>
            <h2>Login Administrativo<i className="fa fa-spin fa-fw fa-spinner pull-right" style={this.props.carregando ? {display: ""} : {display: "none"}}></i></h2>
            <label htmlFor="login">Usuário</label>
            <input type="text" name="login" id="login" value={this.state.credentials.login} className="form-control" placeholder="johndoe" required />
            <label htmlFor="senha">Senha</label>
            <input type="password" name="senha" id="senha" value={this.state.credentials.senha} className="form-control" placeholder="••••••" required/>
            <input type="submit" className="btn-entrar" value="Entrar"/>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    carregando: state.usuario.carregando,
    erro: state.usuario.erro
  };
};

export default connect(mapStateToProps, {login})(Login);



// WEBPACK FOOTER //
// ./src/views/Login.js